import React from "react"

function IconRightArrow() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><title>triangle-right</title><g fill="#000000"><path d="M7.6,2.2A1,1,0,0,0,6,3V21a1,1,0,0,0,1.6.8l12-9a1,1,0,0,0,0-1.6Z" fill="#111111"></path></g></svg>
  )
}

export default IconRightArrow